import styled from "styled-components";



export const ItemWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 8px;
    border-bottom: 1px solid #BABABA;
    position: relative;
    & > .add-menu {
    position: absolute;
    top: 100%;
    right: 0;
    z-index: 1000;
    }
`;

export const ItemLeft = styled.div`
    display: flex;
    flex-direction: row;
    gap: 8px;
    flex: 1;
    align-items: center;
    justify-content: flex-start;
`;
export const MenuIconWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    cursor: pointer;
   
`;


